import type { UserRole, UserType } from '@baseball-near-you/common';
import { createContext, useContext } from 'react';

export const OnboardingContext = createContext<{
  role: UserRole | 'Team Associate' | null;
  setRole: (role: UserRole | 'Team Associate') => void;
  type: UserType | null;
  setType: (type: UserType) => void;
  email: string | null;
  setEmail: (email: string) => void;
  phone: string | null;
  setPhone: (phone: string) => void;
  marketingOptIn: boolean;
  setMarketingOptIn: (marketingOptIn: boolean) => void;
}>({
  role: null,
  setRole: () => {},
  type: null,
  setType: () => {},
  email: null,
  setEmail: () => {},
  phone: null,
  setPhone: () => {},
  marketingOptIn: false,
  setMarketingOptIn: () => {},
});

export const useOnboardingContext = () => useContext(OnboardingContext);
